/* eslint-disable  @typescript-eslint/no-explicit-any, camelcase */
/* Generated types. Do not edit by hand */

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
import * as Types from '../../../graphql.generated'

const defaultOptions = {} as const
export type CoachAvailabilityVideoCallSlotsByParticipantQueryVariables = Types.Exact<{
  uid: Types.Scalars['ID']['input']
}>

export type CoachAvailabilityVideoCallSlotsByParticipantQuery = {
  __typename?: 'Query'
  coachAvailabilityVideoCallSlotsByParticipant: {
    __typename?: 'CoachAvailabilityVideoCallSlotsByParticipant'
    coachProfiles?: Array<{
      __typename?: 'CoachProfile'
      id: string
      firstname?: string | null
      email: string
      lastname?: string | null
      photoUrl?: string | null
      title?: string | null
      description?: string | null
    }> | null
    videoCallSlots?: Array<{
      __typename?: 'VideoCallSlot'
      availabilityCalendarEventID: string
      coachEmail: string
      start: Date
      end: Date
    }> | null
  }
}

export const CoachAvailabilityVideoCallSlotsByParticipantDocument = gql`
  query CoachAvailabilityVideoCallSlotsByParticipant($uid: ID!) {
    coachAvailabilityVideoCallSlotsByParticipant(uid: $uid) {
      coachProfiles {
        id
        firstname
        email
        lastname
        photoUrl
        title
        description
      }
      videoCallSlots {
        availabilityCalendarEventID
        coachEmail
        start
        end
      }
    }
  }
`

/**
 * __useCoachAvailabilityVideoCallSlotsByParticipantQuery__
 *
 * To run a query within a React component, call `useCoachAvailabilityVideoCallSlotsByParticipantQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoachAvailabilityVideoCallSlotsByParticipantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoachAvailabilityVideoCallSlotsByParticipantQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useCoachAvailabilityVideoCallSlotsByParticipantQuery(
  baseOptions: Apollo.QueryHookOptions<
    CoachAvailabilityVideoCallSlotsByParticipantQuery,
    CoachAvailabilityVideoCallSlotsByParticipantQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CoachAvailabilityVideoCallSlotsByParticipantQuery,
    CoachAvailabilityVideoCallSlotsByParticipantQueryVariables
  >(CoachAvailabilityVideoCallSlotsByParticipantDocument, options)
}
export function useCoachAvailabilityVideoCallSlotsByParticipantLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CoachAvailabilityVideoCallSlotsByParticipantQuery,
    CoachAvailabilityVideoCallSlotsByParticipantQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CoachAvailabilityVideoCallSlotsByParticipantQuery,
    CoachAvailabilityVideoCallSlotsByParticipantQueryVariables
  >(CoachAvailabilityVideoCallSlotsByParticipantDocument, options)
}
export type CoachAvailabilityVideoCallSlotsByParticipantQueryHookResult = ReturnType<
  typeof useCoachAvailabilityVideoCallSlotsByParticipantQuery
>
export type CoachAvailabilityVideoCallSlotsByParticipantLazyQueryHookResult = ReturnType<
  typeof useCoachAvailabilityVideoCallSlotsByParticipantLazyQuery
>
export type CoachAvailabilityVideoCallSlotsByParticipantQueryResult = Apollo.QueryResult<
  CoachAvailabilityVideoCallSlotsByParticipantQuery,
  CoachAvailabilityVideoCallSlotsByParticipantQueryVariables
>
